import { Injectable } from "@angular/core";
import { AudioProcessorTask, IAudioProcessorTask } from "../../../core/models/audio-processor-task.model";

@Injectable({
  providedIn: 'root',
})

export class TaskViewerModel {

  public tasks: IAudioProcessorTask[] = [];
  constructor() { }

  hasTasks() {
    return this.tasks.length > 0;
  }

  removeTask(task: IAudioProcessorTask) {
    let index = this.tasks.indexOf(task);
    if (index > -1) {
      this.tasks.splice(index, 1);
    }
  }
}
